import { render, staticRenderFns } from "./PluginCommentModal.vue?vue&type=template&id=5d81f9fb&scoped=true"
import script from "./PluginCommentModal.vue?vue&type=script&lang=js"
export * from "./PluginCommentModal.vue?vue&type=script&lang=js"
import style0 from "./PluginCommentModal.vue?vue&type=style&index=0&id=5d81f9fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d81f9fb",
  null
  
)

export default component.exports